import React, { useEffect, useState } from 'react';
import { HeroSm, NavBar, Spinner } from '../../components';
import { Footer } from '../../layouts';
import $ from 'jquery';
import { Slang } from '../../helpers';




const RegisterBusiness = () => {
  const [loadPage, setLoadPage] = useState(true);
  // const [spinColor, setSpinColor] = useState("success");
  // const clrs = ["primary", "body", "success", "info", "danger", "warning", "info", "success", "light", "dark"];


  useEffect(() => {
    // let tim1 = setInterval(() => {
    //     setSpinColor(clrs[parseInt(Math.random() * 10)]);
    // }, 2000);

    let tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 100);


    return () => {
      clearInterval(tim2);
    };
  }, []);


  return <>

    {
      loadPage
        ? <>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            position: 'fixed',
            left: 0,
            top: 0,
          }}>
            <Spinner color={"success"} size={3} />

          </div>

        </>
        : <Main />
    }

    {/*<Helmet>*/}
    {/*  /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
    {/*  <title>Register your Business</title>*/}
    {/*  <link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
    {/*  <link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
    {/*  <link rel="stylesheet" href="./assets/css/_theme.css" />*/}

    {/*  <script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/prism/prism.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
    {/*  <script defer asyn src="./assets/js/theme.min.js"></script>*/}

    {/*</Helmet>*/}
  </>
}

export default RegisterBusiness;









const Main = () => {

  const lang = Slang('navbar');


  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $('body').append(`<script className="homescript">${script}</script>`)

    return () => {
      $('.homescript').remove();
    };
  }, []);

  return <>
    {window.location.pathname === "add-business" ? <NavBar /> : null}

    <HeroSm title={lang('t5')} />
    <main id="content" role="main">
      <div className="container content-space-3 content-space-t-lg-1 content-space-b-lg-3">
        <div className="flex-grow-1 mx-auto" style={{ maxWidth: "28rem" }}>
          <div className="text-center mb-5 mb-md-7">
            <h1 className="h2"><img src="./assets/img/logos/155x47/initial/PNG/init_gradient.png" alt="logo" style={{ height: '7vh' }} /></h1>
            <p>Fill out the form to get started.</p>
          </div>

          <form className="js-validate needs-validation" noValidate>
            <div className="mb-3">
              <label className="form-label" htmlFor="signupSimpleSignupEmail">Your email</label>
              <input type="email" className="form-control form-control-lg" name="email" id="signupSimpleSignupEmail"
                placeholder="email@site.com" aria-label="email@site.com" required />
              <span className="invalid-feedback">Please enter a valid email address.</span>
            </div>

            <div className="mb-3">
              <label className="form-label" htmlFor="signupSimpleSignupPassword">Password</label>

              <div className="input-group input-group-merge" data-hs-validation-validate-className>
                <input type="password" className="js-toggle-password form-control form-control-lg" name="password"
                  id="signupSimpleSignupPassword" placeholder="8+ characters required" aria-label="8+ characters required" />
                <span className="js-toggle-password-target-1 input-group-append input-group-text" style={{ cursor: "pointer" }}>
                  <i className="js-toggle-passowrd-show-icon-1 bi-eye"></i>
                </span>
              </div>

              <span className="invalid-feedback">Your password is invalid. Please try again.</span>
            </div>

            <div className="mb-3">
              <label className="form-label" htmlFor="signupSimpleSignupConfirmPassword">Confirm password</label>

              <div className="input-group input-group-merge" data-hs-validation-validate-className>
                <input type="password" className="js-toggle-password form-control form-control-lg" name="confirmPassword"
                  id="signupSimpleSignupConfirmPassword" placeholder="8+ characters required"
                  aria-label="8+ characters required" required data-hs-validation-equal-field="#signupSimpleSignupPassword" />
                <span className="js-toggle-password-target-2 input-group-append input-group-text" style={{ cursor: "pointer" }}>
                  <i className="js-toggle-passowrd-show-icon-2 bi-eye"></i>
                </span>
              </div>

              <span className="invalid-feedback">Password does not match the confirm password.</span>
            </div>

            <div className="form-check mb-3">
              <input type="checkbox" className="form-check-input" id="signupHeroFormPrivacyCheck" name="signupFormPrivacyCheck" required />
              <label className="form-check-label small" htmlFor="signupHeroFormPrivacyCheck"> By submitting this form I have read
                and acknowledged the <a href="./page-privacy.html">Privacy Policy</a></label>
              <span className="invalid-feedback">Please accept our Privacy Policy.</span>
            </div>

            <div className="d-grid mb-3">
              <button type="submit" className="btn btn-primary btn-lg">Sign up</button>
            </div>

            <div className="text-center">
              <p>Already have an account? <a className="link" href="./page-login-simple.html">Log in here</a></p>
            </div>
          </form>
        </div>
      </div>
    </main>
    <Footer />
  </>;
};
